import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui-kit/dialog';
import { LeaveCategoryBreakdownTable } from '../leave-category-breakdown-table/leave-category-breakdown-table';
import { LeaveOverviewEmployee } from '../../types/leave-overview.types';

export interface LeaveOverviewDetailDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  employee: LeaveOverviewEmployee | null;
}

/** Full per-category Allocated/Taken/Requested/Remaining breakdown for one employee, reusing the row
 * data `useGetLeaveOverview` already fetched — no extra query on row click. */
export const LeaveOverviewDetailDialog = ({
  open,
  onOpenChange,
  employee,
}: LeaveOverviewDetailDialogProps) => {
  const { t } = useTranslation();

  if (!employee) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* Wide enough for the breakdown's five columns on one line each, so it never scrolls sideways. */}
      <DialogContent className="sm:max-w-2xl" alignCloseWithTitle>
        <DialogHeader>
          <DialogTitle>{t('EMPLOYEE_LEAVE_DETAILS')}</DialogTitle>
        </DialogHeader>

        {/* One line under the title: Name · Department. */}
        <p className="break-words text-sm">
          <span className="font-medium">{employee.DisplayName}</span>
          {employee.DepartmentName && (
            <span className="text-muted-foreground"> · {employee.DepartmentName}</span>
          )}
        </p>

        <LeaveCategoryBreakdownTable categories={employee.Categories} />
      </DialogContent>
    </Dialog>
  );
};
